import React from "react";
import { Card, Header } from "semantic-ui-react";
import { identifyOptions } from "../../../constants";

export const AcademicDetails = ({ profile }) => {
    const expertProfile = profile?.expert_profile ? profile.expert_profile : [];

    return (
        <Card fluid>
            <Card.Content>
                <Card.Header as="h1">Academic Details</Card.Header>
                <>

                    {profile?.affiliations && (
                        <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                            <Header as="h4">Affiliations:</Header>
                            <p>{profile.affiliations}</p>
                        </div>
                    )}

                    {profile?.university && (
                        <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                            <Header as="h4">University:</Header>
                            <p>{profile.university}</p>
                        </div>
                    )}

                    {expertProfile?.length > 0 && (
                        <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                            <Header as="h4">Type of expert:</Header>
                            {expertProfile.map((userIdentify) => {
                                return <p key={userIdentify}>{identifyOptions.find((identify) => identify.key === userIdentify)?.text ?? ""}</p>;
                            })}
                        </div>
                    )}

                    {profile?.faculty_center_institute && (
                        <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                            <Header as="h4">Faculty / Centre / Institute:</Header>
                            <p>{profile?.faculty_center_institute}</p>
                        </div>
                    )}

                    {profile?.department && (
                        <div style={{ display: "flex", paddingTop: "1rem", flexDirection: "row", gap: "1rem" }}>
                            <Header as="h4">Department:</Header>
                            <p>{profile.department}</p>
                        </div>
                    )}
                </>
            </Card.Content>
        </Card>
    );
};
